import {
  Component,
  OnInit,
  input,
  TemplateRef,
  AfterContentInit,
  ContentChildren,
  QueryList,
  ContentChild,
} from '@angular/core';

import { KanziTemplate } from '../../directives/kanzi-template/kanzi-template.directive';

@Component({
    selector: 'kanzi-ui-main-card',
    templateUrl: './kanzi-ui-main-card.component.html',
    styleUrls: ['./kanzi-ui-main-card.component.scss'],
    standalone: false
})
export class KanziUiMainCardComponent implements OnInit, AfterContentInit {
  title = input<string>();
  description = input<string>();
  @ContentChild('rightTopContent') rightTopContent: TemplateRef<any> | null =
    null;
  @ContentChild('bottomContent') bottomContent: TemplateRef<any> | null = null;
  @ContentChild('headerContent')
  headerContent: TemplateRef<any> | null = null;
  @ContentChildren(KanziTemplate) templates: QueryList<KanziTemplate> | null =
    null;
  rightTopContentTemplate: TemplateRef<any> | null = null;
  bottomContentTemplate: TemplateRef<any> | null = null;
  headerContentTemplate: TemplateRef<any> | null = null;

  constructor() {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    (this.templates as QueryList<KanziTemplate>).forEach((item) => {
      switch (item.getType()) {
        case 'rightTopContent':
          this.rightTopContentTemplate = item.template;
          break;
        case 'bottomContent':
          this.bottomContentTemplate = item.template;
          break;
        case 'headerContent':
          this.headerContentTemplate = item.template;
          break;
        default:
          break;
      }
    });
  }
}
